import { Injectable } from '@angular/core';
import { HttpContextToken, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Observable } from 'rxjs';
import { timeout } from 'rxjs/operators';
import { environment } from '#environment';

export const timeoutToken = new HttpContextToken<number>(() => environment.defaultTimeout);

@Injectable()
export class HttpRequestTimeoutInterceptor implements HttpInterceptor {
  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const timeoutDuration = req.context.get(timeoutToken);

    return next.handle(req).pipe(timeout(timeoutDuration));
  }
}
